import { disableModeration, dismissPendingParticipant, enableModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected } from '../av-moderation/actions';
import { MEETING_STATUS } from '../base/app/constants';
import { disconnect } from '../base/connection/actions.any';
import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import { MEDIA_TYPE } from '../base/media/constants';
import { getLocalParticipant, getSpotlightParticipantList, isLocalParticipantModerator } from '../base/participants';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { isLocalTrackMuted } from '../base/tracks/functions.any';
import { updateStatusMeeting } from '../feedback/actions.any';
import { setRemoteParticipants } from '../filmstrip/actions.any';
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from '../notifications';
import { setTimestampStartRecording } from '../recording/actions.any';
import { startCascade, stopCascade } from '../room-cascade/functions';
import { createRoomCascadeSession } from '../room-cascade/slice';
import { setTileViewMode } from '../video-layout/actions.any';
import { muteLocal } from '../video-menu/actions.any';
import { COMMANDS } from './constants';
import { addCommand, sendNotifyMuteMedia } from './slice';
// import i18n from "i18next";
/**
 * Registers a change handler for state['features/base/conference'].conference to
 * set the event listeners needed for the A/V moderation feature to operate.
 */
StateListenerRegistry.register((state) => state["features/base/conference"].conference, (conference, { getState, dispatch }, previousConference) => {
    if (conference && !previousConference) {
        conference.on(JitsiConferenceEvents.MOD_COMMAND_EMIT, ({ commandObj }) => {
            dispatch(addCommand(commandObj));
            switch (true) {
                case COMMANDS.MUTE_MEDIA_BY_TYPE.COMMAND === commandObj.command: {
                    dispatch(muteLocal(true, commandObj.value, (commandObj.value !== MEDIA_TYPE.AUDIO && commandObj.value !== MEDIA_TYPE.VIDEO)));
                    sendNotifyMuteMedia(`${commandObj.value}`, dispatch, getState);
                    break;
                }
                case COMMANDS.CHANGE_CELLS_DISPLAY.COMMANDS === commandObj.command: {
                    dispatch(setTileViewMode(parseInt(`${commandObj.value}`)));
                    break;
                }
                //Quyền bật tắt micro
                case COMMANDS.AUDIO_MODERATION.COMMAND === commandObj.command: {
                    //Tất chế độ cho phép mọi người bật micro trong cuộc họp
                    if (commandObj.value === COMMANDS.AUDIO_MODERATION.ENABLE) {
                        const state = getState();
                        const isLocalModerator = isLocalParticipantModerator(state);
                        if (!isLocalModerator) {
                            const tracks = state['features/base/tracks'];
                            const muteAudio = isLocalTrackMuted(tracks, MEDIA_TYPE.AUDIO);
                            if (!muteAudio) {
                                dispatch(muteLocal(true, MEDIA_TYPE.AUDIO, false));
                            }
                        }
                        dispatch(enableModeration(MEDIA_TYPE.AUDIO, {}));
                    }
                    else {
                        //Bật chế độ cho phép mọi người bật micro trong cuộc họp
                        dispatch(disableModeration(MEDIA_TYPE.AUDIO, {}));
                    }
                    break;
                }
                //Quyền bật tắt camera
                case COMMANDS.VIDEO_MODERATION.COMMAND === commandObj.command: {
                    //Tất chế độ cho phép mọi người bật camera trong cuộc họp
                    if (commandObj.value === COMMANDS.VIDEO_MODERATION.ENABLE) {
                        const state = getState();
                        const isLocalModerator = isLocalParticipantModerator(state);
                        if (!isLocalModerator) {
                            const tracks = state['features/base/tracks'];
                            const muteVideo = isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO);
                            if (!muteVideo) {
                                dispatch(muteLocal(true, MEDIA_TYPE.VIDEO, false));
                            }
                        }
                        dispatch(enableModeration(MEDIA_TYPE.VIDEO, {}));
                    }
                    else {
                        //Bật chế độ cho phép mọi người bật camera trong cuộc họp
                        dispatch(disableModeration(MEDIA_TYPE.VIDEO, {}));
                    }
                    break;
                }
                //Cập nhật trạng thái cho các người có quyền về người được phép bật micro
                case COMMANDS.APPROVE_AUDIO_PARTICIPANT.COMMANDS === commandObj.command: {
                    const state = getState();
                    const isLocalModerator = isLocalParticipantModerator(state);
                    if (isLocalModerator) {
                        dispatch(participantApproved(`${commandObj.value}`, MEDIA_TYPE.AUDIO));
                        dispatch(dismissPendingParticipant(`${commandObj.value}`, MEDIA_TYPE.AUDIO));
                    }
                    break;
                }
                //Cập nhật trạng thái cho các người có quyền về người được phép bật camera
                case COMMANDS.APPROVE_VIDEO_PARTICIPANT.COMMANDS === commandObj.command: {
                    const state = getState();
                    const isLocalModerator = isLocalParticipantModerator(state);
                    if (isLocalModerator) {
                        dispatch(participantApproved(`${commandObj.value}`, MEDIA_TYPE.VIDEO));
                        dispatch(dismissPendingParticipant(`${commandObj.value}`, MEDIA_TYPE.VIDEO));
                    }
                    break;
                }
                case COMMANDS.TURN_ON_MICRO_CASCADE.COMMANDS === commandObj.command: {
                    const state = getState();
                    const isLocalModerator = isLocalParticipantModerator(state);
                    if (isLocalModerator) {
                        dispatch(participantApproved(`${commandObj.value}`, MEDIA_TYPE.AUDIO));
                        dispatch(dismissPendingParticipant(`${commandObj.value}`, MEDIA_TYPE.AUDIO));
                    }
                    break;
                }
                case COMMANDS.TURN_ON_CAMERA_CASCADE.COMMANDS === commandObj.command: {
                    const state = getState();
                    const isLocalModerator = isLocalParticipantModerator(state);
                    if (isLocalModerator) {
                        dispatch(participantApproved(`${commandObj.value}`, MEDIA_TYPE.VIDEO));
                        dispatch(dismissPendingParticipant(`${commandObj.value}`, MEDIA_TYPE.VIDEO));
                    }
                    break;
                }
                case COMMANDS.LOCAL_AUDIO_CASCADE_APPROVED.COMMANDS === commandObj.command: {
                    const state = getState();
                    const localParticipantId = getLocalParticipant(state)?.id;
                    if (localParticipantId == commandObj.value) {
                        dispatch(localParticipantApproved(MEDIA_TYPE.AUDIO));
                        setTimeout(() => {
                            dispatch(muteLocal(false, MEDIA_TYPE.AUDIO));
                        }, 300);
                    }
                    break;
                }
                case COMMANDS.LOCAL_AUDIO_PAR_APPROVED.COMMANDS === commandObj.command: {
                    const state = getState();
                    const localParticipantId = getLocalParticipant(state)?.id;
                    if (localParticipantId == commandObj.value) {
                        dispatch(localParticipantApproved(MEDIA_TYPE.AUDIO));
                        setTimeout(() => {
                            dispatch(showNotification({
                                titleKey: 'notify.openMicParticipant',
                            }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                            dispatch(muteLocal(false, MEDIA_TYPE.AUDIO));
                        }, 300);
                    }
                    break;
                }
                case COMMANDS.LOCAL_VIDEO_CASCADE_APPROVED.COMMANDS === commandObj.command: {
                    const state = getState();
                    const localParticipantId = getLocalParticipant(state)?.id;
                    if (localParticipantId == commandObj.value) {
                        dispatch(localParticipantApproved(MEDIA_TYPE.VIDEO));
                        setTimeout(() => {
                            dispatch(muteLocal(false, MEDIA_TYPE.VIDEO));
                        }, 300);
                    }
                    break;
                }
                case COMMANDS.LOCAL_VIDEO_PAR_APPROVED.COMMANDS === commandObj.command: {
                    const state = getState();
                    const localParticipantId = getLocalParticipant(state)?.id;
                    if (localParticipantId == commandObj.value) {
                        dispatch(localParticipantApproved(MEDIA_TYPE.VIDEO));
                        setTimeout(() => {
                            dispatch(showNotification({
                                titleKey: 'notify.openVideoParticipant',
                            }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                            dispatch(muteLocal(false, MEDIA_TYPE.VIDEO));
                        }, 300);
                    }
                    break;
                }
                //Cập nhật trạng thái cho các người có quyền về người không được phép bật micro
                case COMMANDS.REJECT_AUDIO_PARTICIPANT.COMMANDS === commandObj.command: {
                    const state = getState();
                    const isLocalModerator = isLocalParticipantModerator(state);
                    if (isLocalModerator) {
                        dispatch(participantRejected(`${commandObj.value}`, MEDIA_TYPE.AUDIO));
                        dispatch(dismissPendingParticipant(`${commandObj.value}`, MEDIA_TYPE.AUDIO));
                    }
                    break;
                }
                //Cập nhật trạng thái cho người bị cấm micro
                case COMMANDS.LOCAL_AUDIO_PARTICIPANT_REJECTED.COMMANDS === commandObj.command: {
                    const state = getState();
                    const localParticipantId = getLocalParticipant(state)?.id;
                    if (localParticipantId == commandObj.value) {
                        const tracks = state['features/base/tracks'];
                        const muteAudio = isLocalTrackMuted(tracks, MEDIA_TYPE.AUDIO);
                        if (!muteAudio) {
                            dispatch(muteLocal(true, MEDIA_TYPE.AUDIO, false));
                        }
                        dispatch(localParticipantRejected(MEDIA_TYPE.AUDIO));
                    }
                    break;
                }
                //Cập nhật trạng thái cho cascade bị cấm micro
                case COMMANDS.LOCAL_AUDIO_CASCADE_REJECTED.COMMANDS === commandObj.command: {
                    const state = getState();
                    const localParticipantId = getLocalParticipant(state)?.id;
                    if (localParticipantId == commandObj.value) {
                        const tracks = state['features/base/tracks'];
                        const muteAudio = isLocalTrackMuted(tracks, MEDIA_TYPE.AUDIO);
                        if (!muteAudio) {
                            dispatch(muteLocal(true, MEDIA_TYPE.AUDIO, false));
                        }
                    }
                    break;
                }
                //Cập nhật trạng thái cho các người có quyền về người không được phép bật camera
                case COMMANDS.REJECT_VIDEO_PARTICIPANT.COMMANDS === commandObj.command: {
                    const state = getState();
                    const isLocalModerator = isLocalParticipantModerator(state);
                    if (isLocalModerator) {
                        dispatch(participantRejected(`${commandObj.value}`, MEDIA_TYPE.VIDEO));
                        dispatch(dismissPendingParticipant(`${commandObj.value}`, MEDIA_TYPE.VIDEO));
                    }
                    break;
                }
                //Cập nhật trạng thái cho người bị cấm camera
                case COMMANDS.LOCAL_VIDEO_PARTICIPANT_REJECTED.COMMANDS === commandObj.command: {
                    const state = getState();
                    const localParticipantId = getLocalParticipant(state)?.id;
                    if (localParticipantId == commandObj.value) {
                        const tracks = state['features/base/tracks'];
                        const muteVideo = isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO);
                        if (!muteVideo) {
                            dispatch(muteLocal(true, MEDIA_TYPE.VIDEO, false));
                        }
                        dispatch(localParticipantRejected(MEDIA_TYPE.VIDEO));
                    }
                    break;
                }
                //Cập nhật trạng thái cho cascade bị cấm camera
                case COMMANDS.LOCAL_VIDEO_CASCADE_REJECTED.COMMANDS === commandObj.command: {
                    const state = getState();
                    const localParticipantId = getLocalParticipant(state)?.id;
                    if (localParticipantId == commandObj.value) {
                        const tracks = state['features/base/tracks'];
                        const muteVideo = isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO);
                        if (!muteVideo) {
                            dispatch(muteLocal(true, MEDIA_TYPE.VIDEO, false));
                        }
                    }
                    break;
                }
                case COMMANDS.RECORDING.START_RECORDING === commandObj.command: {
                    const value = commandObj.value ? +commandObj.value : undefined;
                    dispatch(setTimestampStartRecording(value));
                    break;
                }
                case COMMANDS.ROOM.COMMAND === commandObj.command: {
                    dispatch(disconnect(true));
                    setTimeout(() => {
                        dispatch(updateStatusMeeting(MEETING_STATUS.END));
                    }, 500);
                    break;
                }
                case COMMANDS.ROOM_CASCADE.COMMAND === commandObj.command: {
                    const commands = `${commandObj.value}`.split("|");
                    if (COMMANDS.ROOM_CASCADE.START === commands[0]) {
                        dispatch(createRoomCascadeSession(commands[1], commands[2], commands[3], commands[4]));
                        setTimeout(() => {
                            startCascade(getState(), commands[1]);
                        }, 300);
                        dispatch(showNotification({
                            titleKey: `Start cascade to ${commands[1]} with password ${commands[2]}`
                        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                    }
                    else if (COMMANDS.ROOM_CASCADE.STOP === commands[0]) {
                        stopCascade(getState(), commands[1]);
                        // titleKey: `Stop cascade to ${commands[1]}`
                        dispatch(showNotification({
                            titleKey: `roomCascade.notification.success.stop`
                        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                    }
                    break;
                }
                case COMMANDS.SORT_PARTICIPANTS.COMMANDS === commandObj.command: {
                    const state = getState();
                    const participants = getSpotlightParticipantList(state);
                    dispatch(setRemoteParticipants(participants));
                    break;
                }
                default: {
                    console.log(`Command ${commandObj.command} is not supported`);
                }
            }
        });
    }
});
